import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class SubCategoryMarkUpBus extends BaseBus
{
    constructor(data: SubCategoryMarkUpBus) {
        super(data);
    }

    CID(): any {
        return this.subCategoryMarkUpId;
    }
    setId(id: any) {
        this.subCategoryMarkUpId = id;
    }
    initialize(data: SubCategoryMarkUpBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
       // this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: SubCategoryMarkUpBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        if (this.hasId) {
            this.updateUserId = userId;
        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
            this.updateUserId = userId;
        }
    }
    subCategoryPricetypeId :number;
    subCategoryPricetype :string;
    subCategoryMarkUpId: string;
    parentId: string;
    inventorySubCategoryId: string;
    inventorySubCategory: string;
    markup: number;
    insertDt: Date;
    updateDt: Date;
    updateUserId: string;
    insertUserId: string;
    createdDt: string;
    createdUser: string;
    get markupPercent(): number {
        return this.markup * 100;
    }
    set markupPercent(value: number) {
        this.markup = value / 100;
    }
}
